import React from 'react';
import styled from '@emotion/native';
import { Title } from './styledComponents';
import { green } from '@/shared/styles/colors';
import { LoraText } from '@/shared/components/StyledText';
import useExploreStore from '@/stores/useExploreStore';
import Checkbox from '@/shared/components/Checkbox';

const InPersonAvailabilityFilter = () => {
  const { filters, setFilters } = useExploreStore();
  const isSelected = filters.availableInPerson === true;

  const handleToggle = () => {
    setFilters({
      availableInPerson: isSelected ? null : true,
    });
  };

  return (
    <Container>
      <Title>Filter by Availability:</Title>
      <CheckBoxContainer>
        <Checkbox checked={isSelected} onPress={handleToggle} />
        <LabelText selected={isSelected}>Available In Person</LabelText>
      </CheckBoxContainer>
    </Container>
  );
};

const Container = styled.View({
  marginBottom: 32,
});

const CheckBoxContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
});

const LabelText = styled(LoraText)<{ selected: boolean }>(({ selected }) => ({
  fontSize: 15,
  letterSpacing: 2.4,
  color: green,
  marginLeft: 8,
  fontWeight: selected ? 'bold' : 500,
}));

export default InPersonAvailabilityFilter;
